export default "__VITE_ASSET__a061b280__"